import React from 'react';
export enum SkeletonType {
  avatar = 'avatar',
  thumbnail = 'thumbnail ',
  text_lg = 'text-lg',
  text_md = 'text-md',
  text_sm = 'text-sm',
}
const Skeleton = ({ type }: { type: SkeletonType }) => {
  return (
    <div className='skeleton'>
      <div className={type}> </div>
    </div>
  );
};

export default Skeleton;
